import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static values = {
    content: String
  }

  show(event) {
    if (this.label) return

    this.label = document.createElement('div')
    this.label.className = 'cursor-tooltip'
    this.label.textContent = this.contentValue
    document.body.append(this.label)
    this.#moveTo(event)
  }

  follow(event) {
    this.#moveTo(event)
  }

  hide() {
    this.label?.remove()
    this.label = null
  }

  disconnect() {
    this.hide()
  }

  #moveTo(event) {
    this.label.style.setProperty('--cursor-tooltip-x', `${event.clientX}px`)
    this.label.style.setProperty('--cursor-tooltip-y', `${event.clientY}px`)
  }
}
